module.exports = __webpack_public_path__ + "media/images/emblems/L_Abbaye-coat_of_arms-83f40e4120396fd385515f26f0b28336.svg";